import { FigmaAutoLayout } from './FigmaLayout';
import {
  Frame427319936Start,
  GoldPageRoot,
} from './GoldFigmaComponents';
import { clampVwMax, pxH, pxW } from './figmaScale';
import { FIGMA_SPEC } from './figmaSpec';
import styles from './GoldEntryPage.module.scss';
import brand from '../../images/gold/brand.png';
import heroRibbon from '../../images/gold/overlay.png';
import arrowIcon from '../../images/gold/right.png';

const E = FIGMA_SPEC.entry;

function GoldEntryPage({ updateState }) {
  return (
    <GoldPageRoot bg="entry">
      <img src={heroRibbon} alt="" className={styles.ribbon291} aria-hidden />

      <FigmaAutoLayout
        direction="vertical"
        align="stretch"
        className={styles.slide141}
        style={{
          height: '100%',
          padding: `${pxH(E.logo.padTop)} ${pxW(E.mainPadX)} ${pxH(E.ctaBottom)}`,
          position: 'relative',
          zIndex: 2,
        }}
      >
        <header className={styles.image290Header}>
          <img
            src={brand}
            alt="World Gold Council"
            className={styles.image290Entry}
            style={{
              height: pxH(E.logo.h),
              width: 'auto',
              maxWidth: pxW(E.logo.w),
            }}
          />
        </header>

        <FigmaAutoLayout
          direction="vertical"
          align="start"
          className={styles.heroBlock}
          style={{ paddingTop: pxH(E.heroPadTop) }}
        >
          <h1
            className={styles.headline}
            style={{
              fontSize: pxH(E.headline.fontSize),
              maxWidth: pxW(E.headline.maxW),
              lineHeight: E.headline.lineHeight,
            }}
          >
            <span className={styles.headlineLine}>Step Into Your</span>
            <span className={styles.headlineLine}>
              <span className={styles.shimmerGolden}>Golden</span>
              <span className={styles.headlineWord}> Moment</span>
            </span>
          </h1>

          <div
            className={styles.ctaRow}
            style={{ marginTop: pxH(E.ctaMarginTop) }}
          >
            <Frame427319936Start
              label="Start Experience"
              arrowSrc={arrowIcon}
              className={styles.entryCta}
              onClick={() => updateState(0)}
              outerStyle={{
                width: clampVwMax(E.ctaOuter.w),
                height: clampVwMax(E.ctaOuter.h),
                padding: `${clampVwMax(E.ctaOuter.padY)} ${clampVwMax(E.ctaOuter.padX)}`,
              }}
              labelStyle={{ fontSize: clampVwMax(E.ctaLabel.fontSize) }}
              innerStyle={{ minHeight: clampVwMax(E.ctaInner.h) }}
              arrowStyle={{
                width: clampVwMax(E.ctaArrow.w),
                height: clampVwMax(E.ctaArrow.h),
              }}
              iconStyle={{
                width: clampVwMax(E.ctaIcon.w),
                height: clampVwMax(E.ctaIcon.h),
              }}
            />
          </div>
        </FigmaAutoLayout>
      </FigmaAutoLayout>
    </GoldPageRoot>
  );
}

export default GoldEntryPage;
